import React from "react";
import { Link } from "react-router-dom";
import { PrimaryButton } from "../../../components/buttons";
import { OnboardingNav } from "../../../components/Nav/BottomNav";
import { Onboarding } from "../../../components/Sections/Onboarding";

const Home1 = () => {
  return (
    <div>
      <Onboarding
        linkto={"/signup"}
        heading={"Real Estate: A Foundation for Growth"}
        body={
          "We own and operate the premier logistics real estate portfolio in the markets that matter."
        }
        imgurl={"/img/new/background/home1.jpeg"}
        next={"/home2"}
      />
    </div>
  );
};

export default Home1;
